import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from "./images/Online Quran_Landscape (1).png";
import {
  BookOpen,
  ChevronRight,
  Menu,
  X
} from 'lucide-react';
import MosqueIcon from '@mui/icons-material/Mosque';


const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Courses', path: '/courses' },
    { label: 'Services', path: '/services' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'Contact', path: '/contact' },

  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="fixed top-0 left-0 right-0 z-50  sm h-[60px] bg-gradient-to-r from-green-900 via-green-800 to-green-900 shadow-none sm" style={{ paddingBottom: '0 !important' }}>
        <div className="h-full px-4 md:px-6 mx-auto sm">
          <div className="h-[60px] min-h-[60px] flex items-center justify-between w-full">

            {/* LOGO */}
           
            <div className="flex-shrink-0">
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => navigate('/')}
              >
                {/* Adjusted the padding and max-width of the white box 
        to accommodate the larger logo 
    */}
                <div className="bg-white rounded-xl p-2 md:p-1 shadow-lg flex items-center justify-center">
                  <img
                    src={Logo}
                    alt="Online Quran Institute"
                  
                    className="object-contain w-20 sm:w-28 md:w-32 lg:w-40 h-auto transition-all duration-300"
                  />
                </div>
              </div>
            </div>

            {/* DESKTOP NAV - White Menu Bar */}
            <div className="hidden lg:block  bg-white shadow-md">
              <div className="max-w-7xl mx-auto flex justify-center gap-2 py-2">
                {navItems.map((item) => (
                  <Link
                    key={item.label}
                    to={item.path}
                    className="text-green-900 px-4 py-1 text-sm md:text-base hover:bg-green-100 rounded-md transition-colors whitespace-nowrap font-medium"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>


            {/* RIGHT SIDE - Icons & CTA */}
            <div className="flex items-center gap-2">
              <div className="hidden sm:flex items-center gap-2 mr-3">

              </div>
              <button
                onClick={() => navigate("/lead-form")}
                className="hidden lg:flex items-center gap-2 bg-yellow-400 text-black px-4 py-2 rounded-md hover:bg-yellow-500 transition-colors text-sm md:text-base font-medium whitespace-nowrap min-w-[140px] justify-center"
              >
                Quick Join Now
                <ChevronRight className="w-4 h-4" />
              </button>


              {/* MOBILE MENU BUTTON */}
              <button
                onClick={handleDrawerToggle}
                className="lg:hidden text-white p-1 hover:bg-white/10 rounded-md transition-colors"
              >
                {mobileOpen ? (
                  <X className="w-5 h-5" />
                ) : (
                  <Menu className="w-5 h-5" />
                )}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Spacer to prevent content from hiding behind fixed navbar */}
      <div className="h-[35px] flex-shrink-0" />

      {/* ================= MOBILE DRAWER ================= */}
      <div className={`fixed inset-0 z-50 transition-all duration-300 ${mobileOpen ? 'visible' : 'invisible'}`}>
        {/* Backdrop */}
        <div
          className={`absolute inset-0 bg-black/50 transition-opacity ${mobileOpen ? 'opacity-100' : 'opacity-0'}`}
          onClick={handleDrawerToggle}
        />

        {/* Drawer Panel */}
        <div className={`absolute right-0 top-0 h-full w-64 shadow-xl transition-transform duration-300 ${mobileOpen ? 'translate-x-0' : 'translate-x-full'}`}>

          <div className="p-5 h-full">
            {/* Drawer Header */}
            <div
              className="flex items-center gap-2 mb-6 cursor-pointer"
              onClick={() => {
                navigate('/');
                setMobileOpen(false);
              }}
            >
              <div className="w-9 h-9 bg-gradient-to-br from-emerald-300 to-emerald-600 rounded-md flex items-center justify-center">
                <BookOpen className="text-white w-5 h-5" />
              </div>
              <span className="text-white text-lg font-medium ml-2">
                Online Quran<span className="text-base mx-1"><MosqueIcon /></span>Islamic Institute
              </span>
            </div>

            {/* Drawer Menu Items */}
            <div className="space-y-2">
              {/* TOP HALF - White BG, Black Text */}
              {navItems.slice(0, 3).map((item) => (
                <div
                  key={item.label}
                  onClick={() => {
                    navigate(item.path);
                    setMobileOpen(false);
                  }}
                  className="bg-white text-black px-4 py-3 rounded-md hover:bg-gray-200 transition-colors cursor-pointer text-base font-medium"
                >
                  {item.label}
                </div>
              ))}

              {/* BOTTOM HALF - Dark Green BG, White Text */}
              {navItems.slice(3).map((item) => (
                <div
                  key={item.label}
                  onClick={() => {
                    navigate(item.path);
                    setMobileOpen(false);
                  }}
                  className="bg-green-800 text-white px-4 py-3 rounded-md hover:bg-green-900 transition-colors cursor-pointer text-base font-medium"
                >
                  {item.label}
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;